import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

/**
 * InfantDisclaimerText component.
 * Renders the informational disclaimer for minor passenger travel (e.g. inside an alert or passenger notice block).
 * @param {object} props - ulStyle.
 * @param {object} props.ulStyle - Inline styles for the disclaimer list.
 * @returns {JSX.Element} Disclaimer content.
 */
const InfantDisclaimerText = ({ ulStyle }) => {
  const brand = useSelector((state) => state.whitelabelConfig?.env?.brand);
  const { t } = useTranslation('passengers');

  return (
    <Trans
      i18nKey="infant_disclaimer"
      t={t}
      values={{ context: brand }}
      components={{
        1: <strong />,
        ul: <ul style={ulStyle} />,
        li: <li />,
      }}
    />
  );
};

InfantDisclaimerText.propTypes = {
  ulStyle: PropTypes.object,
};

InfantDisclaimerText.defaultProps = {
  ulStyle: { listStyleType: 'disc' },
};

export default InfantDisclaimerText;
